import { useEffect, useRef } from "react";

export default function Hero() {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    video.muted = true;
    video.defaultMuted = true;

    const startPlayback = () => {
      const playPromise = video.play();
      if (playPromise && typeof playPromise.catch === "function") {
        playPromise.catch(() => {
          // Autoplay may be blocked until user interaction; retry silently.
        });
      }
    };

    startPlayback();

    const handleReady = () => startPlayback();
    video.addEventListener("loadeddata", handleReady);
    video.addEventListener("canplay", handleReady);
    video.addEventListener("canplaythrough", handleReady);

    return () => {
      video.removeEventListener("loadeddata", handleReady);
      video.removeEventListener("canplay", handleReady);
      video.removeEventListener("canplaythrough", handleReady);
    };
  }, []);

  return (
    <section className="relative flex h-screen min-h-[640px] w-full items-center overflow-hidden">
      <div className="absolute inset-0 h-full w-full bg-foreground-950">
        <video
          ref={videoRef}
          className="h-full w-full object-cover object-top"
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
          aria-label="EV retrofit technology showcase video"
        >
          <source
            src="https://storage.helloreaddy.io/project_files/cfdf9c1d-8697-4270-b5da-2ba099c8fbf6/41cf09ee-3f62-4881-a318-04a1799d558b_The-Clean-Fleet-Revo...---IntellemoAI-1.mp4"
            type="video/mp4"
          />
        </video>
      </div>
    </section>
  );
}